// @flow
import React from "react";
import AllowsOvernight from "../../../svg/facilities/allows_overnight.svg";

import "./allowsOvernightIcon.scss";

const AllowsOvernightIcon = () => (
  <AllowsOvernight className="c-allows-overnight-icon" />
);

export default AllowsOvernightIcon;
